"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeValuesEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = require("../../shared/propTypes");

var _ValidValuesHeader = require("../../shared/ValidValuesHeader");

var _RangeValueEditor = require("./RangeValueEditor");

var _RangeValuesDisplay = require("./RangeValuesDisplay");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var RangeValuesEditor = function RangeValuesEditor(_ref) {
  var attribute = _ref.attribute,
      values = _ref.values,
      onValuesChanged = _ref.onValuesChanged,
      enforceValidValues = _ref.enforceValidValues;

  var onValueAdded = function onValueAdded(newValue) {
    var updatedRanges = [].concat(_toConsumableArray(values), [newValue]);
    onValuesChanged(updatedRanges);
  };

  var onValueRemoved = function onValueRemoved(removedRangeValue) {
    var updatedRanges = values.filter(function (rangeValue) {
      return rangeValue.range.minimum !== removedRangeValue.range.minimum || rangeValue.range.maximum !== removedRangeValue.range.maximum || rangeValue.range.increment !== removedRangeValue.range.increment;
    });
    onValuesChanged(updatedRanges);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null, attribute ?
    /*#__PURE__*/
    _react["default"].createElement(_ValidValuesHeader.ValidValuesHeader, {
      attribute: attribute
    }) : null,
    /*#__PURE__*/
    _react["default"].createElement(_RangeValueEditor.RangeValueEditor, {
      existingValues: values,
      validValues: attribute ? attribute.values : null,
      onValueAdded: onValueAdded,
      enforceValidValues: enforceValidValues
    }),
    /*#__PURE__*/
    _react["default"].createElement(_RangeValuesDisplay.RangeValuesDisplay, {
      values: values,
      onValueRemoved: onValueRemoved
    }))
  );
};

exports.RangeValuesEditor = RangeValuesEditor;
RangeValuesEditor.propTypes = {
  attribute: _propTypes["default"].shape(_propTypes2.atttributeShape),
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  onValuesChanged: _propTypes["default"].func.isRequired,
  enforceValidValues: _propTypes["default"].bool
};
RangeValuesEditor.defaultProps = {
  values: [],
  enforceValidValues: false
};